export default __webpack_public_path__ + "img/QualityMarketRewardsLogo-01.png";